module.exports = __webpack_public_path__ + "static/media/logo_horizontal.6307e6f6.svg";